import React from 'react';
import {connect} from "react-redux";
import {Button, message, Modal, Space, Table} from "antd";
import {adminLoadHostingAccountCPanelDomains} from "../../actions/hosting";
import {displayErrors} from "../../libs/utils";
import {CheckSquareOutlined, CopyOutlined} from "@ant-design/icons";
import {adminCreateDomainsInCpanel} from "../../actions/domains";

class HostingAccountCompareWithCPanel extends React.Component {
    state = {
        loadingDomains: false,
        domainsLoaded: false,
        domains: [],
        selectedDomains: []
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps !== prevState) {
            return nextProps;
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.showModal && !this.state.loadingDomains && !this.state.domainsLoaded) {
            this.setState({ loadingDomains: true });

            this.props.adminLoadHostingAccountCPanelDomains(this.props.guid, (res) => {
                this.setState({ loadingDomains: false, domainsLoaded: true, domains: res.data });
            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    this.setState({ loading: false });
                    displayErrors(err.response.data);
                }
            });
        }
    }

    closeModal() {
        this.setState({
            loadingDomains: false,
            domainsLoaded: false,
            domains: [],
            selectedDomains: []
        }, () => this.props.close())
    }

    adminCopySelectedDomains() {
        let domains = [];

        for(let i = 0; i < this.state.domains.length; i++) {
            for(let j = 0; j < this.state.selectedDomains.length; j++) {
                if(this.state.domains[i].domain === this.state.selectedDomains[j]) {
                    domains.push(this.state.domains[i].domain);
                }
            }
        }

        navigator.clipboard.writeText(domains.join('\n'));
        message.success('Domains successfully copied to clipboard!');
    }

    selectNonExistentDomains() {
        let domains = this.state.domains.filter(domain => domain.exists_in_cpanel === false).map(domain => domain.domain);
        this.setState({ selectedDomains: domains });
    }

    render() {
        const columns = [
            { title: 'Domain', dataIndex: 'domain' },
            {
                title: 'In cPanel?',
                dataIndex: 'exists_in_cpanel',
                render: (text) => text ? <span style={{color: 'green'}}>Yes</span> :
                    <span style={{color: 'red'}}>No</span>
            },
            {
                title: 'In DB?',
                dataIndex: 'exists_in_database',
                render: (text) => text ? <span style={{color: 'green'}}>Yes</span> :
                    <span style={{color: 'red'}}>No</span>
            },
        ]

        return <Modal
            title='Domain Comparison with cPanel'
            open={this.props.showModal}
            onCancel={() => this.closeModal()}
            width={600}
            footer={false}>
            <Space>
                <Button onClick={() => this.selectNonExistentDomains()} size='small' icon={<CheckSquareOutlined />}>Select Non-existent</Button>
                <Button size='small' onClick={() => this.adminCopySelectedDomains()} icon={<CopyOutlined />}>Copy Selected</Button>
            </Space>
            <Table
                dataSource={this.state.domains}
                loading={this.state.loadingDomains}
                rowKey={(item) => item.domain}
                size='small'
                rowSelection={{
                    type: 'checkbox',
                    selectedRowKeys: this.state.selectedDomains,
                    onChange: (domains) => this.setState({ selectedDomains: domains })
                }}
                columns={columns} pagination={false} />
        </Modal>
    }
}

export default connect(null, { adminLoadHostingAccountCPanelDomains, adminCreateDomainsInCpanel })(HostingAccountCompareWithCPanel);